import { motion } from 'framer-motion';

/**
 * Kept intentionally simple: three bouncing dots. Tailwind's `animate-bounce`
 * drives the loop (cheap, GPU-friendly); `motion-reduce:animate-none` makes it
 * static under `prefers-reduced-motion` even though it's a raw CSS animation
 * rather than a framer-motion one (MotionConfig's reducedMotion="user" only
 * covers framer-motion-driven props).
 */
export const TypingIndicator = () => (
  <motion.div
    initial={{ opacity: 0, y: 4 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    className="flex justify-start"
  >
    <div className="rounded-lg border border-border bg-card px-3.5 py-2.5">
      <div className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-1.5 w-1.5 animate-bounce rounded-full bg-muted-foreground/50 motion-reduce:animate-none"
            style={{ animationDelay: `${i * 0.12}s` }}
          />
        ))}
      </div>
    </div>
  </motion.div>
);
